import {
  GET_ALL,
  GET_ALL_FAILURE,
  GET_ALL_SUCCESS,
  ADD,
  ADD_FAILURE,
  ADD_SUCCESS,
  DELETE,
  DELETE_FAILURE,
  DELETE_SUCCESS,
  EDIT,
  EDIT_FAILURE,
  EDIT_SUCCESS,
  GET,
  GET_FAILURE,
  GET_SUCCESS,
} from "./actionTypes";

export const getAllPaymentMethods = (payload) => {
  return {
    type: GET_ALL,
    payload: payload,
  };
};
export const getAllPaymentMethodsSuccess = (payload) => {
  return {
    type: GET_ALL_SUCCESS,
    payload: payload,
  };
};

export const getAllPaymentMethodsFailure = (error) => {
  return {
    type: GET_ALL_FAILURE,
    payload: error,
  };
};

export const addPaymentMethod = (payload) => {
  return {
    type: ADD,
    payload: payload,
  };
};
export const addPaymentMethodSuccess = (payload) => {
  return {
    type: ADD_SUCCESS,
    payload: payload,
  };
};

export const addPaymentMethodFailure = (error) => {
  return {
    type: ADD_FAILURE,
    payload: error,
  };
};

export const getPaymentMethod = (payload) => {
  return {
    type: GET,
    payload: payload,
  };
};
export const getPaymentMethodSuccess = (payload) => {
  return {
    type: GET_SUCCESS,
    payload: payload,
  };
};

export const getPaymentMethodFailure = (error) => {
  return {
    type: GET_FAILURE,
    payload: error,
  };
};

export const editPaymentMethod = (payload) => {
  return {
    type: EDIT,
    payload: payload,
  };
};
export const editPaymentMethodSuccess = (payload) => {
  return {
    type: EDIT_SUCCESS,
    payload: payload,
  };
};

export const editPaymentMethodFailure = (error) => {
  return {
    type: EDIT_FAILURE,
    payload: error,
  };
};

export const deletePaymentMethod = (payload) => {
  return {
    type: DELETE,
    payload: payload,
  };
};

export const deletePaymentMethodSuccess = (payload) => {
  return {
    type: DELETE_SUCCESS,
    payload: payload,
  };
};

export const deletePaymentMethodFailure = (error) => {
  return {
    type: DELETE_FAILURE,
    payload: error,
  };
};
